import { render, staticRenderFns } from "./BInputGroupAppendIcon.vue?vue&type=template&id=5128abc4&scoped=true&"
import script from "./BInputGroupAppendIcon.vue?vue&type=script&lang=js&"
export * from "./BInputGroupAppendIcon.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5128abc4",
  null
  
)

export default component.exports